import { useMutation } from '@tanstack/react-query'
import { removeWorkerFromRoster } from 'api/worker'
import { useAuthContext } from 'components/auth'

interface UseRemoveWorkerFromRosterMutation {
  rosterId: number
  onSuccess?: () => void
  onError?: (err: Error) => void
}

export function useRemoveWorkerFromRosterMutation(
  options: UseRemoveWorkerFromRosterMutation
) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (workerId: number) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }

      return removeWorkerFromRoster(company.id, options.rosterId, workerId)
    },
    ...options,
  })
}
